import React, { Component } from 'react';
// index.js or App.js
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../css/style.css';
// import NET from "vantajs/dist/vanta.net.min";
import NET from 'vanta/dist/vanta.net.min';

import Navbar from '../components/Navbar';
import IndustriesSection from '../components/IndustriesSection';
import ServicesSection from '../components/ServicesSection';
import CompaniesCarousel from '../components/CompanyCarousel';
// import homebanner from '../images/main-home-banner-img.png';


class VancouverSecurity extends Component {
    
  constructor(props) {
    super(props);
     this.vantaRef = React.createRef()
    this.state = {
      formData: {
        name: '',
        email: '',
        phone: '',
        serviceType: '',
        message: '',
        
      },
      isSubmitting: false,
      activeIndex: 0,
      previousIndex: 0,
      images: [
        '../images/main-home-banner-img.png',
        '../images/3.png',
      ],
      fade: false,
      heroSlides: [
        {
          image: "../images/main-home-banner-img.png",
          title: "VANCOUVER",
          subtitle: "Protect your property with AI-powered video monitoring and real-time response"
        },
        {
          image: "../images/3.png",
          title: "CALGARY",
          subtitle: "Manage entry points, monitor sites, and stay connected from anywhere, 24/7"
        },
        {
          image: "../images/cam-banner.png",
          title: "EDMONTON",
          subtitle: "Showcase your projects with professional time-lapse videos and smart reporting"
        },
         {
          image: "../images/2.jpg",
          title: "VICTORIA",
          subtitle: "Protect your property with AI-powered video monitoring and real-time response"
        },
        // {
        //   image: "../images/3.jpg",
        //   title: "CALGARY",
        //   subtitle: "Manage entry points, monitor sites, and stay connected from anywhere, 24/7"
        // },
        // {
        //   image: "../images/4.jpg",
        //   title: "EDMONTON",
        //   subtitle: "Showcase your projects with professional time-lapse videos and smart reporting"
        // },
        {
          image: "../images/5.jpg",
          title: "OTTAWA",
          subtitle: "Showcase your projects with professional time-lapse videos and smart reporting"
        },
        {
          image: "../images/banner6.png",
          title: "TORONTO",
          subtitle: "Showcase your projects with professional time-lapse videos and smart reporting"
        }
      ]
    };
    
    // Refs for animations
    this.heroTitleRef = React.createRef();
    this.statsGridRef = React.createRef();
    this.navbarRef = React.createRef();
    this.techBgRef = React.createRef();
    
    // Bind methods
    this.handleScroll = this.handleScroll.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.createRipple = this.createRipple.bind(this);
    this.animateCounters = this.animateCounters.bind(this);
    this.typeWriter = this.typeWriter.bind(this);
  }

  componentDidMount() {
    console.log("this.vantaEffect==",this.vantaEffect)
     if (!this.vantaEffect) {
      this.vantaEffect = NET({
        el: this.vantaRef.current,
        color: 0x00ff00,           // bright green (change as you want)
        backgroundColor: 0x000000, // black bg or use transparent color
        points: 10,
        maxDistance: 20,
        spacing: 18,
      });
    }
    // Add event listeners
    //this.startCarousel();
    window.addEventListener('scroll', this.handleScroll);
    
    // Initialize animations
    //this.initializeAnimations();
    this.initializeIntersectionObserver();
    this.initializeStatsObserver();
    this.addRippleEffects();
    //this.add3DCardEffects();
    
    // Add typewriter effect with delay
    // setTimeout(() => {
    //   if (this.heroTitleRef.current) {
    //     this.typeWriter(this.heroTitleRef.current, 'VANCOUVER', 150);
    //   }
    // }, 500);

    // Add page load animation
    document.body.style.opacity = '0';
    setTimeout(() => {
      document.body.style.transition = 'opacity 0.5s ease-in-out';
      document.body.style.opacity = '1';
    }, 100);

    // Add smooth scrolling for navigation
    //this.addSmoothScrolling();
  }

  componentWillUnmount() {
    if (this.vantaEffect) this.vantaEffect.destroy()
    //clearInterval(this.interval);
    window.removeEventListener('scroll', this.handleScroll);
    if (this.observer) this.observer.disconnect();
    if (this.statsObserver) this.statsObserver.disconnect();
  }

  startCarousel = () => {
    this.interval = setInterval(() => {
      this.setState((prevState) => {
        const nextIndex = (prevState.activeIndex + 1) % prevState.images.length;
        return {
          previousIndex: prevState.activeIndex,
          activeIndex: nextIndex,
          fade: true,
        };
      });

      // Disable fade after animation
      setTimeout(() => {
        this.setState({ fade: false });
      }, 1000); // match with CSS transition duration
    }, 5000); // 5s per slide
  };

  handleScroll() {
    const scrolled = window.pageYOffset;
    
    // Navbar background change
    if (this.navbarRef.current) {
      if (scrolled > 50) {
        this.navbarRef.current.style.background = 'rgba(10, 25, 41, 0.98)';
        this.navbarRef.current.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.3)';
      } else {
        this.navbarRef.current.style.background = 'rgba(10, 25, 41, 0.95)';
        this.navbarRef.current.style.boxShadow = 'none';
      }
    }

    // Parallax effect for background
    if (this.techBgRef.current) {
      this.techBgRef.current.style.transform = `translateY(${scrolled * 0.5}px)`;
    }
  }

  initializeAnimations() {
    // Add CSS animations
    const style = document.createElement('style');
    style.textContent = `
      
    `;
    document.head.appendChild(style);
  }

  initializeIntersectionObserver() {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    }, observerOptions);

    // Observe all elements with animate-on-scroll class
    setTimeout(() => {
      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        this.observer.observe(el);
      });
    }, 100);
  }

  initializeStatsObserver() {
    this.statsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateCounters();
          this.statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    setTimeout(() => {
      if (this.statsGridRef.current) {
        this.statsObserver.observe(this.statsGridRef.current);
      }
    }, 100);
  }

  animateCounters() {
    const counters = document.querySelectorAll('.stat-number');
    
    counters.forEach(counter => {
      const text = counter.textContent;
      let target;
      
      if (text.includes('+')) {
        target = parseInt(text);
      } else if (text.includes('/')) {
        counter.textContent = '24/7';
        return;
      } else if (text.includes('%')) {
        target = parseFloat(text);
      } else {
        target = parseInt(text);
      }
      
      const duration = 2000;
      const increment = target / (duration / 16);
      let current = 0;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        
        if (text.includes('+')) {
          counter.textContent = Math.floor(current) + '+';
        } else if (text.includes('%')) {
          counter.textContent = current.toFixed(1) + '%';
        } else {
          counter.textContent = Math.floor(current);
        }
      }, 16);
    });
  }

  typeWriter(element, text, speed = 100) {
    let i = 0;
    element.textContent = '';
    
    const type = () => {
      if (i < text.length) {
        element.textContent += text.charAt(i);
        i++;
        setTimeout(type, speed);
      }
    };
    type();
  }

  addSmoothScrolling() {
    setTimeout(() => {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const target = document.querySelector(anchor.getAttribute('href'));
          if (target) {
            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      });
    }, 100);
  }

  addRippleEffects() {
    setTimeout(() => {
      document.querySelectorAll('.btn, .service-card, .stat-card').forEach(element => {
        element.addEventListener('click', this.createRipple);
        element.style.position = 'relative';
        element.style.overflow = 'hidden';
      });
    }, 100);
  }

  createRipple(event) {
    const button = event.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add('ripple');

    const ripple = button.getElementsByClassName('ripple')[0];
    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  }

  add3DCardEffects() {
    setTimeout(() => {
      document.querySelectorAll('.service-card, .why-card').forEach(card => {
        card.addEventListener('mousemove', (e) => {
          const rect = card.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;
          
          const rotateX = (y - centerY) / 10;
          const rotateY = (centerX - x) / 10;
          
          card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-10px)`;
        });
        
        card.addEventListener('mouseleave', () => {
          card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateY(0)';
        });
      });

      // Add floating animation to service cards
      document.querySelectorAll('.service-card').forEach((card, index) => {
        card.style.animationDelay = `${index * 0.1}s`;
        card.addEventListener('mouseenter', function() {
          this.style.transform = 'translateY(-15px) scale(1.02)';
        });
        card.addEventListener('mouseleave', function() {
          this.style.transform = 'translateY(0) scale(1)';
        });
      });

      // Add glow effect on hover for buttons
      document.querySelectorAll('.btn-primary').forEach(btn => {
        btn.addEventListener('mouseenter', function() {
          this.style.boxShadow = '0 15px 30px rgba(6, 182, 212, 0.4), 0 0 30px rgba(6, 182, 212, 0.3)';
        });
        btn.addEventListener('mouseleave', function() {
          this.style.boxShadow = '0 15px 30px rgba(6, 182, 212, 0.4)';
        });
      });
    }, 100);
  }

  handleFormChange(e) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  }

  handleFormSubmit(e) {
    e.preventDefault();
    
    this.setState({ isSubmitting: true });
    
    // Simulate form submission
    setTimeout(() => {
      alert('Thank you for your inquiry! We will contact you within 24 hours.');
      this.setState({
        formData: {
          name: '',
          email: '',
          phone: '',
          serviceType: '',
          message: ''
        },
        isSubmitting: false
      });
    }, 2000);
  }

 
  render() {
    const { formData, isSubmitting } = this.state;
// const thebanner = {homebanner};
// console.log("thebanner===",thebanner)

const { images, activeIndex, previousIndex, fade } = this.state;
console.log("images===",images)
    const backgroundImage = `url(${images[activeIndex]})`;
    return (
      <div>
        {/* Background */}
        
       
        
        {/* <Navbar /> */}
        

       
<div className='mainn' ref={this.vantaRef}>
<Carousel fade indicators={false} controls={true} interval={3000} pause={false}>
  {this.state.heroSlides.map((slide, index) => (
    <Carousel.Item key={index}>
      <section
        id="home"
        
        className="hero-section d-flex align-items-center"
        style={{
          backgroundImage: `url(${slide.image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          // height: "100vh"
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        ></div>


        <div className="container position-relative text-white">
          <div className="row align-items-center mt-150">
            <div className="col-lg-12 text-center">
              <h1 className="hero-title orbitron">{slide.title}</h1>
              <p className="hero-subtitle">{slide.subtitle}</p>
              <button className="orbitron btn btn-outline-light btn-lg px-4 py-2 mt-3">
                <a className='anchorStyle' href='/services'>LEARN MORE</a>
              </button>
            </div>
          </div>

          {/* ✅ Stats Section */}
          <div className="row stats-grid mt-5">
            <div className="col-lg-12 text-center">
              <p className="hero-phone">
                <i className="fas fa-phone me-2"></i>+1 (604) 343-5245 (British Columbia Office)
                <span className="mx-3">|</span>
                <i className="fas fa-phone me-2"></i>+1 (403) 992-1672 (Alberta Office)
                {/* <span className="mx-3">|</span>
                <i className="fas fa-phone me-2"></i>(604) 343-5245 (BC) */}
              </p>
            </div>
            <div className="col-md-4 mb-4">
              <div className="stat-card text-center">
                <div className="stat-number orbitron">100+</div>
                <div className="text-muted">CLIENTS PROTECTED</div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="stat-card text-center">
                <div className="stat-number orbitron">1000+</div>
                <div className="text-muted">PROJECTS</div>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="stat-card text-center">
                <div className="stat-number orbitron">24/7</div>
                <div className="text-muted">MONITORING</div>
              </div>
            </div>
            {/* <div className="col-md-4 mb-4">
              <div className="stat-card text-center">
                <div className="stat-number orbitron">99.9%</div>
                <div className="text-muted">UPTIME</div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </Carousel.Item>
  ))}
</Carousel>
</div>



    {/* Services Section */}
    <ServicesSection/>

    <section className="py-5 text-white d-flex align-items-center" style={{ minHeight: '650px', backgroundImage: 'url("../images/Background-about.png")', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed' }}>
      {/* Dark overlay */}
      {/* <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-75"></div> */}
      
      <div className="container">
      <div className="row">
              <div className="col-12 text-center mb-5">
                <div className="d-flex justify-content-center align-items-center mb-3">
                  <div className="bg-white rounded-circle p-2 me-3">
                    <i className="fas fa-shield-alt text-white"></i>
                  </div>
                  <span className="text-uppercase text-white small-upper-text">TOP TIER</span>
                </div>
                <h2 className="display-5 fw-bold">About Us</h2>
                {/* <p className="lead text-muted mx-auto" style={{maxWidth: '800px'}}>
                  Lorem ipsum dolor sit amet consectetur. Risus nullam nisl nibh dictum sem laoreet 
                  bibendum et pellentesque. Faucibus etiam pretium aliquet phasellus massa pretium.
                </p> */}
              </div>
            </div>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 col-12 text-center">
            {/* <h2 className="display-4 fw-bold mb-4 text-white">About Us</h2> */}
            <p className="lead mb-4 text-white about-content">
              At Sterling Surveillance Technologies LTD, we deliver advanced, technology-driven security solutions designed to meet the evolving needs of modern businesses and communities across Canada. Backed by years of industry experience, our team of highly trained security professionals and industry specialists are committed to providing proactive, reliable, and responsive protection 24 hours a day, 7 days a week.

</p>

           
            <p className="lead mb-4 text-white about-content">
            Utilizing cutting-edge AI-powered surveillance systems, real-time monitoring, and strategic on-site and mobile patrol services, we ensure the highest standard of safety and operational excellence for every client. Our tailored approach allows us to safeguard a wide range of environments—including residential developments, commercial properties, and active construction sites—with precision and accountability.

            </p>
<p className="lead mb-4 text-white about-content">
            We are not just a security provider—we are a trusted partner in protection, risk mitigation, and peace of mind.
            </p>
            <button class="orbitron btn btn-outline-light btn-lg px-4 py-2 mt-3" ><a className='anchorStyle' href="/services">LEARN MORE</a></button>
          </div>
        </div>
      </div>
    </section>



       {/* Industries Section */}
       <IndustriesSection/>


       
    <div>
      {/* Companies Section */}
      <section className="companies-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <p className="text-white mb-4" style={{ fontSize: '16px', fontWeight: '400' }}>
                Join 100+ companies already growing
              </p>
              <CompaniesCarousel/>
              {/* <div className="d-flex flex-wrap justify-content-center align-items-center gap-4 gap-md-5">
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#60a5fa', fontSize: '24px' }}>🔵</span>
                  OdeaoLabs
                </div>
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#fbbf24', fontSize: '24px' }}>❄️</span>
                  Kintsugi
                </div>
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#60a5fa', fontSize: '24px' }}>📊</span>
                  StackEd Lab
                </div>
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#ec4899', fontSize: '24px' }}>🌸</span>
                  Magnolia
                </div>
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#60a5fa', fontSize: '24px' }}>🔗</span>
                  Warpspeed
                </div>
                <div className="d-flex align-items-center text-white" style={{ fontSize: '18px', fontWeight: '600' }}>
                  <span className="me-2" style={{ color: '#10b981', fontSize: '24px' }}>🔒</span>
                  Sisyphus
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* AI-Powered Visual Intelligence Section */}
      <section className="py-5 ai-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <h2 class="display-5 fw-bold mb-4">AI-POWERED VISUAL INTELLIGENCE</h2>
              {/* <h1 className="text-white mb-4" style={{ 
                fontSize: 'clamp(28px, 4vw, 42px)', 
                fontWeight: '700', 
                letterSpacing: '2px',
                lineHeight: '1.2'
              }}>
                AI-POWERED VISUAL INTELLIGENCE
              </h1> */}
              <p className="text-white mb-5" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                Unlock the power of computer vision with our advanced AI models
              </p>
              
              <div className="border-start border-primary ps-4" style={{ borderColor: '#3b82f6 !important', borderWidth: '3px !important' }}>
                <div className="mb-5">
                  <h4 className="text-white mb-2" style={{ fontSize: '20px', fontWeight: '600' }}>
                    Human Detection
                  </h4>
                  <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Real-time identification and tracking of individuals in video feeds or static images.
                  </p>
                </div>
                
                <div className="mb-5">
                  <h4 className="text-white mb-2" style={{ fontSize: '20px', fontWeight: '600' }}>
                    Vehicle Detection
                  </h4>
                  <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Recognize and track cars, bikes, and other vehicles in various environment.
                  </p>
                </div>
                
                <div className="mb-5">
                  <h4 className="text-white mb-2" style={{ fontSize: '20px', fontWeight: '600' }}>
                    License Plate Recognition (LPR)
                  </h4>
                  <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Accurate detection and reading of license plates for surveillance and automation
                  </p>
                </div>
                
                <div className="mb-5">
                  <h4 className="text-white mb-2" style={{ fontSize: '20px', fontWeight: '600' }}>
                    Face Analysis
                  </h4>
                  <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Identify facial features, emotions, and unique characteristics with deep-learning-based models
                  </p>
                </div>
                
                <div className="mb-0">
                  <h4 className="text-white mb-2" style={{ fontSize: '20px', fontWeight: '600' }}>
                    Image Enhancement
                  </h4>
                  <p className="text-white mb-0" style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Improve low-resolution, blurred, or poorly lit images using AI-based restoration
                  </p>
                </div>
              </div>
            </div>
            
            <div className="col-lg-6 col-md-12 text-center">
              <div className="position-relative d-inline-block w-100">
                <img class="mw-100" alt="ai-cam" src="../images/camera.png"/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

        {/* Features Section */}
        {/* <section className="features-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <div className="feature-image animate-on-scroll">
                  <div style={{height: '400px', background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-cyan)', fontSize: '4rem'}}>
                    <i className="fas fa-shield-alt"></i>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="feature-content animate-on-scroll">
                  <h3 className="orbitron">OUR FEATURES</h3>
                  <p className="text-muted mb-4">Advanced technology meets reliable security solutions</p>
                  <ul className="feature-list">
                    <li>AI-Powered Threat Detection</li>
                    <li>Cloud-Based Storage Solutions</li>
                    <li>Real-Time Alert Systems</li>
                    <li>Mobile App Integration</li>
                    <li>Advanced Analytics Dashboard</li>
                    <li>Scalable System Architecture</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Why Sterling Section */}
        <section className="why-sterling-section">
          <div className="container">
          {/* <div className="d-flex justify-content-center align-items-center mb-3">
                  <div className="bg-white rounded-circle p-2 me-3">
                    <i className="fas fa-shield-alt text-white"></i>
                  </div>
                  <span className="text-uppercase text-white small-upper-text">WHO WE WORK WITH</span>
                </div>
            <h2 class="display-5 fw-bold mb-10">WHY STERLING PROTECTION?</h2> */}
          <div className="row">
              <div className="col-12 text-left mb-5">
                <div className="d-flex justify-content-left align-items-left mb-3">
                  <div className="bg-white rounded-circle p-2 me-3">
                    <i className="fas fa-shield-alt text-white"></i>
                  </div>
                  <span className="text-uppercase text-white small-upper-text">WHY CHOOSE US</span>
                </div>
                <h2 className="display-5 fw-bold mb-double">WHY Sterling Surveillance Technologies?</h2>
                {/* <p className="lead text-muted mx-auto" style={{maxWidth: '800px'}}>
                  Lorem ipsum dolor sit amet consectetur. Risus nullam nisl nibh dictum sem laoreet 
                  bibendum et pellentesque. Faucibus etiam pretium aliquet phasellus massa pretium.
                </p> */}
              </div>
            </div>
          <div className="row">
              <div className="col-lg-6 mb-4 position-relative">
              <div className="why-number orbitron">01</div>
                <div className="why-card animate-on-scroll">
                  
                  <img alt="star" src='../images/star.svg'/>
                  <h4 className="why-title">Experience</h4>
                  <p className="text-muted">Over a decade of experience in providing top-tier security solutions with proven track record of excellence.</p>
                </div>
              </div>
              <div className="col-lg-6 mb-4 position-relative">
              <div className="why-number orbitron">02</div>
                <div className="why-card animate-on-scroll">
                <img alt="star" src='../images/star.svg'/>
                  <h4 className="why-title">24/7 Service</h4>
                  <p className="text-muted">Round-the-clock monitoring and support services ensuring your security needs are always covered.</p>
                </div>
              </div>
              <div className="col-lg-6 mb-4 position-relative">
              <div className="why-number orbitron">03</div>
                <div className="why-card animate-on-scroll">
                <img alt="star" src='../images/star.svg'/>
                  <h4 className="why-title">Advanced Technology</h4>
                  <p className="text-muted">Cutting-edge security technology and innovative solutions tailored to modern security challenges.</p>
                </div>
              </div>
              <div className="col-lg-6 mb-4 position-relative">
              <div className="why-number orbitron">04</div>
                <div className="why-card animate-on-scroll">
                <img alt="star" src='../images/star.svg'/>
                  <h4 className="why-title">Trusted Reputation</h4>
                  <p className="text-muted">Built a reputation of trust and reliability with hundreds of satisfied clients across various industries.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Exceptional Service Section */}
        {/* <section className="exceptional-section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-5 mb-lg-0">
                <div className="animate-on-scroll">
                  <div style={{height: '400px', background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent-cyan)', fontSize: '4rem'}}>
                    <i className="fas fa-cog fa-spin"></i>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <h3 className="orbitron text-info mb-4 animate-on-scroll">OUR EXCEPTIONAL SERVICE</h3>
                <div className="exceptional-card animate-on-scroll">
                  <h5 className="text-light">Customized Security Solutions</h5>
                  <p className="text-muted">Tailored security systems designed specifically for your unique requirements and environment.</p>
                </div>
                <div className="exceptional-card animate-on-scroll">
                  <h5 className="text-light">Professional Installation</h5>
                  <p className="text-muted">Expert installation services ensuring optimal system performance and minimal disruption.</p>
                </div>
                <div className="exceptional-card animate-on-scroll">
                  <h5 className="text-light">Ongoing Maintenance</h5>
                  <p className="text-muted">Regular maintenance and updates to keep your security systems operating at peak efficiency.</p>
                </div>
                <div className="exceptional-card animate-on-scroll">
                  <h5 className="text-light">Emergency Response</h5>
                  <p className="text-muted">Rapid response team available 24/7 for emergency situations and critical security alerts.</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Contact Section */}
        <section id="contact" className="contact-section">
          <div className="container">
            {/* <h2 className="section-title orbitron animate-on-scroll">GET A QUOTE</h2>
            <p className="text-center text-muted mb-5 animate-on-scroll">Contact us today for a free security assessment and customized quote</p> */}
            
            <h2 class="display-5 fw-bold mb-4">GET IN TOUCH</h2>
              
              <p className="text-white mb-5" style={{ fontSize: '16px', lineHeight: '1.6' }}>
              If you have any questions or need assistance, feel free to reach out to our support team. We're  here to help you every step of the way.
              </p>
            <div className="row justify-content-center">
              <div className="col-lg-12">
                <form className="animate-on-scroll" onSubmit={this.handleFormSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Your Name" 
                        name="name"
                        value={formData.name}
                        onChange={this.handleFormChange}
                        required 
                      />
                    </div>
                    <div className="col-md-6">
                      <input 
                        type="email" 
                        className="form-control" 
                        placeholder="Email Address" 
                        name="email"
                        value={formData.email}
                        onChange={this.handleFormChange}
                        required 
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <input 
                        type="tel" 
                        className="form-control" 
                        placeholder="Phone Number" 
                        name="phone"
                        value={formData.phone}
                        onChange={this.handleFormChange}
                        required 
                      />
                    </div>
                    <div className="col-md-6">
                      <select 
                        className="form-control" 
                        name="serviceType"
                        value={formData.serviceType}
                        onChange={this.handleFormChange}
                        required
                      >
                        <option value="">Select Service Type</option>
                        <option value="surveillance">Video Surveillance</option>
                        <option value="access">Remote Access Control</option>
                        <option value="Concierge">Concierge Services</option>
                        <option value="time">Time Lapse Video</option>
                        <option value="AI">AI Based Detection</option>
                      </select>
                    </div>
                  </div>
                  <textarea 
                    className="form-control" 
                    rows="5" 
                    placeholder="Tell us about your security needs..." 
                    name="message"
                    value={formData.message}
                    onChange={this.handleFormChange}
                    required
                  ></textarea>
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                      {isSubmitting ? 'SENDING...' : 'SEND'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
       
      </div>
    );
  }
}

export default VancouverSecurity;